import React from "react";
import { Dialog, DialogContent, Stack, Checkbox } from "@mui/material";
import MDButton from "components/MDButton";
import { cancelCheckout } from "../../../../redux/actions/RatActions";
import { useDispatch } from "react-redux";
import { useState } from "react";

const CancelCheckout = ({
  open,
  close,
  guestdetails,
  editGuestHandler,
  handleCloseGuestModalWindow,
}) => {
  const [checked, setChecked] = React.useState(false);
  const [select, setSelect] = useState("");
  const dispatch = useDispatch();
  const proceed = () => {
    console.log(guestdetails.id);
    if (checked) {
      setSelect("");
      dispatch(cancelCheckout(guestdetails.id));
      handleCloseGuestModalWindow();
      editGuestHandler();
    } else {
      setSelect("Please Select Checkbox");
    }
  };

  const handleDisable = () => {
    setDisable(true);
  }
  const handleChange = (event) => {
    setChecked(event.target.checked);
    setSelect("");
    
  };
  console.log(checked);
  return (
    <div style={{ width: "90%", height: 100 }}>
      <strong>Are You Sure You Want Cancel the Checkout</strong>
      <Checkbox
        checked={checked}
        onChange={handleChange}
        inputProps={{ "aria-label": "controlled" }}
      />
      Yes
      <br/>
      <small style={{color:"red"}}>{select}</small>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="flex-end"
        alignItems="flex-end"
      >
        <MDButton
          size="small"
          variant="contained"
          color="info"
          width="5%"
          onClick=
            {proceed}
        >
          Proceed
        </MDButton>
      </Stack>
    </div>
  );
};

export default CancelCheckout;
